import { cva, VariantProps } from 'class-variance-authority';
import styles from './border.module.css';
import type { InputType } from 'storybook/internal/types';

export const borderVariants = cva('', {
  variants: {
    borderRadius: {
      none: styles['borderRadiusNone'],
      '6xs': styles['borderRadius6xs'],
      '5xs': styles['borderRadius5xs'],
      '4xs': styles['borderRadius4xs'],
      '3xs': styles['borderRadius3xs'],
      '2xs': styles['borderRadius2xs'],
      xs: styles['borderRadiusXs'],
      sm: styles['borderRadiusSm'],
      md: styles['borderRadiusMd'],
      lg: styles['borderRadiusLg'],
      xl: styles['borderRadiusXl'],
      circle: styles['borderRadiusCircle'],
      card: styles['borderRadiusCard'],
    },
    borderWidth: {
      none: styles['borderWidthNone'],
      xs: styles['borderWidthXs'],
      sm: styles['borderWidthSm'],
      md: styles['borderWidthMd'],
      lg: styles['borderWidthLg'],
      xl: styles['borderWidthXl'],
    },
    borderStyle: {
      none: styles['borderStyleNone'],
      solid: styles['borderStyleSolid'],
      dashed: styles['borderStyleDashed'],
    },
    borderColour: {
      none: styles['borderColourNone'],
      secondary: styles['borderColourSecondary'],
      tertiary: styles['borderColourTertiary'],
      accent: styles['borderColourAccent'],
      caution: styles['borderColourCaution'],
      critical: styles['borderColourCritical'],
      information: styles['borderColourInformation'],
      inverse: styles['borderColourInverse'],
      success: styles['borderColourSuccess'],
      warning: styles['borderColourWarning'],
      white: styles['borderColourWhite'],
    },
    borderTopWidth: {
      none: styles['borderTopWidthNone'],
      xs: styles['borderTopWidthXs'],
      sm: styles['borderTopWidthSm'],
      md: styles['borderTopWidthMd'],
      lg: styles['borderTopWidthLg'],
      xl: styles['borderTopWidthXl'],
    },
    borderTopRadius: {
      none: styles['borderTopRadiusNone'],
      '6xs': styles['borderTopRadius6xs'],
      '5xs': styles['borderTopRadius5xs'],
      '4xs': styles['borderTopRadius4xs'],
      '3xs': styles['borderTopRadius3xs'],
      '2xs': styles['borderTopRadius2xs'],
      xs: styles['borderTopRadiusXs'],
      sm: styles['borderTopRadiusSm'],
      md: styles['borderTopRadiusMd'],
      lg: styles['borderTopRadiusLg'],
      xl: styles['borderTopRadiusXl'],
      circle: styles['borderTopRadiusCircle'],
      card: styles['borderTopRadiusCard'],
    },
    borderTopStyle: {
      none: styles['borderTopStyleNone'],
      solid: styles['borderTopStyleSolid'],
      dashed: styles['borderTopStyleDashed'],
    },
    borderTopColour: {
      none: styles['borderTopColourNone'],
      secondary: styles['borderTopColourSecondary'],
      tertiary: styles['borderTopColourTertiary'],
      accent: styles['borderTopColourAccent'],
      caution: styles['borderTopColourCaution'],
      critical: styles['borderTopColourCritical'],
      information: styles['borderTopColourInformation'],
      inverse: styles['borderTopColourInverse'],
      success: styles['borderTopColourSuccess'],
      warning: styles['borderTopColourWarning'],
      white: styles['borderTopColourWhite'],
    },
    borderRightWidth: {
      none: styles['borderRightWidthNone'],
      xs: styles['borderRightWidthXs'],
      sm: styles['borderRightWidthSm'],
      md: styles['borderRightWidthMd'],
      lg: styles['borderRightWidthLg'],
      xl: styles['borderRightWidthXl'],
    },
    borderRightRadius: {
      none: styles['borderRightRadiusNone'],
      '6xs': styles['borderRightRadius6xs'],
      '5xs': styles['borderRightRadius5xs'],
      '4xs': styles['borderRightRadius4xs'],
      '3xs': styles['borderRightRadius3xs'],
      '2xs': styles['borderRightRadius2xs'],
      xs: styles['borderRightRadiusXs'],
      sm: styles['borderRightRadiusSm'],
      md: styles['borderRightRadiusMd'],
      lg: styles['borderRightRadiusLg'],
      xl: styles['borderRightRadiusXl'],
      circle: styles['borderRightRadiusCircle'],
      card: styles['borderRightRadiusCard'],
    },
    borderRightStyle: {
      none: styles['borderRightStyleNone'],
      solid: styles['borderRightStyleSolid'],
      dashed: styles['borderRightStyleDashed'],
    },
    borderRightColour: {
      none: styles['borderRightColourNone'],
      secondary: styles['borderRightColourSecondary'],
      tertiary: styles['borderRightColourTertiary'],
      accent: styles['borderRightColourAccent'],
      caution: styles['borderRightColourCaution'],
      critical: styles['borderRightColourCritical'],
      information: styles['borderRightColourInformation'],
      inverse: styles['borderRightColourInverse'],
      success: styles['borderRightColourSuccess'],
      warning: styles['borderRightColourWarning'],
      white: styles['borderRightColourWhite'],
    },
    borderBottomWidth: {
      none: styles['borderBottomWidthNone'],
      xs: styles['borderBottomWidthXs'],
      sm: styles['borderBottomWidthSm'],
      md: styles['borderBottomWidthMd'],
      lg: styles['borderBottomWidthLg'],
      xl: styles['borderBottomWidthXl'],
    },
    borderBottomRadius: {
      none: styles['borderBottomRadiusNone'],
      '6xs': styles['borderBottomRadius6xs'],
      '5xs': styles['borderBottomRadius5xs'],
      '4xs': styles['borderBottomRadius4xs'],
      '3xs': styles['borderBottomRadius3xs'],
      '2xs': styles['borderBottomRadius2xs'],
      xs: styles['borderBottomRadiusXs'],
      sm: styles['borderBottomRadiusSm'],
      md: styles['borderBottomRadiusMd'],
      lg: styles['borderBottomRadiusLg'],
      xl: styles['borderBottomRadiusXl'],
      circle: styles['borderBottomRadiusCircle'],
      card: styles['borderBottomRadiusCard'],
    },
    borderBottomStyle: {
      none: styles['borderBottomStyleNone'],
      solid: styles['borderBottomStyleSolid'],
      dashed: styles['borderBottomStyleDashed'],
    },
    borderBottomColour: {
      none: styles['borderBottomColourNone'],
      secondary: styles['borderBottomColourSecondary'],
      tertiary: styles['borderBottomColourTertiary'],
      accent: styles['borderBottomColourAccent'],
      caution: styles['borderBottomColourCaution'],
      critical: styles['borderBottomColourCritical'],
      information: styles['borderBottomColourInformation'],
      inverse: styles['borderBottomColourInverse'],
      success: styles['borderBottomColourSuccess'],
      warning: styles['borderBottomColourWarning'],
      white: styles['borderBottomColourWhite'],
    },
    borderLeftWidth: {
      none: styles['borderLeftWidthNone'],
      xs: styles['borderLeftWidthXs'],
      sm: styles['borderLeftWidthSm'],
      md: styles['borderLeftWidthMd'],
      lg: styles['borderLeftWidthLg'],
      xl: styles['borderLeftWidthXl'],
    },
    borderLeftRadius: {
      none: styles['borderLeftRadiusNone'],
      '6xs': styles['borderLeftRadius6xs'],
      '5xs': styles['borderLeftRadius5xs'],
      '4xs': styles['borderLeftRadius4xs'],
      '3xs': styles['borderLeftRadius3xs'],
      '2xs': styles['borderLeftRadius2xs'],
      xs: styles['borderLeftRadiusXs'],
      sm: styles['borderLeftRadiusSm'],
      md: styles['borderLeftRadiusMd'],
      lg: styles['borderLeftRadiusLg'],
      xl: styles['borderLeftRadiusXl'],
      circle: styles['borderLeftRadiusCircle'],
      card: styles['borderLeftRadiusCard'],
    },
    borderLeftStyle: {
      none: styles['borderLeftStyleNone'],
      solid: styles['borderLeftStyleSolid'],
      dashed: styles['borderLeftStyleDashed'],
    },
    borderLeftColour: {
      none: styles['borderLeftColourNone'],
      secondary: styles['borderLeftColourSecondary'],
      tertiary: styles['borderLeftColourTertiary'],
      accent: styles['borderLeftColourAccent'],
      caution: styles['borderLeftColourCaution'],
      critical: styles['borderLeftColourCritical'],
      information: styles['borderLeftColourInformation'],
      inverse: styles['borderLeftColourInverse'],
      success: styles['borderLeftColourSuccess'],
      warning: styles['borderLeftColourWarning'],
      white: styles['borderLeftColourWhite'],
    },
    borderRadiusTopLeft: {
      none: styles['borderRadiusTopLeftNone'],
      '6xs': styles['borderRadiusTopLeft6xs'],
      '5xs': styles['borderRadiusTopLeft5xs'],
      '4xs': styles['borderRadiusTopLeft4xs'],
      '3xs': styles['borderRadiusTopLeft3xs'],
      '2xs': styles['borderRadiusTopLeft2xs'],
      xs: styles['borderRadiusTopLeftXs'],
      sm: styles['borderRadiusTopLeftSm'],
      md: styles['borderRadiusTopLeftMd'],
      lg: styles['borderRadiusTopLeftLg'],
      xl: styles['borderRadiusTopLeftXl'],
      circle: styles['borderRadiusTopLeftCircle'],
      card: styles['borderRadiusTopLeftCard'],
    },
    borderRadiusTopRight: {
      none: styles['borderRadiusTopRightNone'],
      '6xs': styles['borderRadiusTopRight6xs'],
      '5xs': styles['borderRadiusTopRight5xs'],
      '4xs': styles['borderRadiusTopRight4xs'],
      '3xs': styles['borderRadiusTopRight3xs'],
      '2xs': styles['borderRadiusTopRight2xs'],
      xs: styles['borderRadiusTopRightXs'],
      sm: styles['borderRadiusTopRightSm'],
      md: styles['borderRadiusTopRightMd'],
      lg: styles['borderRadiusTopRightLg'],
      xl: styles['borderRadiusTopRightXl'],
      circle: styles['borderRadiusTopRightCircle'],
      card: styles['borderRadiusTopRightCard'],
    },
    borderRadiusBottomLeft: {
      none: styles['borderRadiusBottomLeftNone'],
      '6xs': styles['borderRadiusBottomLeft6xs'],
      '5xs': styles['borderRadiusBottomLeft5xs'],
      '4xs': styles['borderRadiusBottomLeft4xs'],
      '3xs': styles['borderRadiusBottomLeft3xs'],
      '2xs': styles['borderRadiusBottomLeft2xs'],
      xs: styles['borderRadiusBottomLeftXs'],
      sm: styles['borderRadiusBottomLeftSm'],
      md: styles['borderRadiusBottomLeftMd'],
      lg: styles['borderRadiusBottomLeftLg'],
      xl: styles['borderRadiusBottomLeftXl'],
      circle: styles['borderRadiusBottomLeftCircle'],
      card: styles['borderRadiusBottomLeftCard'],
    },
    borderRadiusBottomRight: {
      none: styles['borderRadiusBottomRightNone'],
      '6xs': styles['borderRadiusBottomRight6xs'],
      '5xs': styles['borderRadiusBottomRight5xs'],
      '4xs': styles['borderRadiusBottomRight4xs'],
      '3xs': styles['borderRadiusBottomRight3xs'],
      '2xs': styles['borderRadiusBottomRight2xs'],
      xs: styles['borderRadiusBottomRightXs'],
      sm: styles['borderRadiusBottomRightSm'],
      md: styles['borderRadiusBottomRightMd'],
      lg: styles['borderRadiusBottomRightLg'],
      xl: styles['borderRadiusBottomRightXl'],
      circle: styles['borderRadiusBottomRightCircle'],
      card: styles['borderRadiusBottomRightCard'],
    },
  },
  defaultVariants: {
    borderRadius: 'none',
    borderWidth: 'none',
    borderStyle: 'solid',
    borderColour: 'none',
  },
});

export type BorderVariants = VariantProps<typeof borderVariants>;

const borderRadiusOptions = [
  'none',
  '6xs',
  '5xs',
  '4xs',
  '3xs',
  '2xs',
  'xs',
  'sm',
  'md',
  'lg',
  'xl',
  'circle',
  'card',
] as const;

export const borderWidthOptions = [
  'none',
  'xs',
  'sm',
  'md',
  'lg',
  'xl',
] as const;

export const borderStyleOptions = ['none', 'solid', 'dashed'] as const;

export const borderColourOptions = [
  'none',
  'secondary',
  'tertiary',
  'accent',
  'caution',
  'critical',
  'information',
  'inverse',
  'success',
  'warning',
  'white',
] as const;

export const borderTopWidthOptions = borderWidthOptions;
export const borderTopRadiusOptions = borderRadiusOptions;
export const borderTopStyleOptions = borderStyleOptions;
export const borderTopColourOptions = borderColourOptions;
export const borderRightWidthOptions = borderWidthOptions;
export const borderRightRadiusOptions = borderRadiusOptions;
export const borderRightStyleOptions = borderStyleOptions;
export const borderRightColourOptions = borderColourOptions;
export const borderBottomWidthOptions = borderWidthOptions;
export const borderBottomRadiusOptions = borderRadiusOptions;
export const borderBottomStyleOptions = borderStyleOptions;
export const borderBottomColourOptions = borderColourOptions;
export const borderLeftWidthOptions = borderWidthOptions;
export const borderLeftRadiusOptions = borderRadiusOptions;
export const borderLeftStyleOptions = borderStyleOptions;
export const borderLeftColourOptions = borderColourOptions;

// Corner-specific radius options
export const borderRadiusTopLeftOptions = borderRadiusOptions;
export const borderRadiusTopRightOptions = borderRadiusOptions;
export const borderRadiusBottomLeftOptions = borderRadiusOptions;
export const borderRadiusBottomRightOptions = borderRadiusOptions;

export const borderArgTypes: Record<string, InputType> = {
  borderRadius: {
    control: 'select',
    options: borderRadiusOptions,
    description: 'Border radius for rounded corners using design system tokens',
    table: {
      type: { summary: 'BorderRadius' },
      category: 'Border',
    },
  },
  borderWidth: {
    control: 'select',
    options: borderWidthOptions,
    description: 'Border width using design system tokens',
    table: {
      type: { summary: 'BorderWidth' },
      category: 'Border',
    },
  },
  borderStyle: {
    control: 'select',
    options: borderStyleOptions,
    description: 'Border style (none, solid, or dashed)',
    table: {
      type: { summary: 'none | solid | dashed' },
      category: 'Border',
    },
  },
  borderColour: {
    control: 'select',
    options: borderColourOptions,
    description: 'Border color using semantic color tokens',
    table: {
      type: { summary: 'BorderColor' },
      category: 'Border',
    },
  },
  borderTopWidth: {
    control: 'select',
    options: borderTopWidthOptions,
    description: 'Top border width using design system tokens',
    table: {
      type: { summary: 'BorderWidth' },
      category: 'Border',
      subcategory: 'Border Top',
    },
  },
  borderTopRadius: {
    control: 'select',
    options: borderTopRadiusOptions,
    description:
      '@deprecated Use borderRadiusTopLeft and borderRadiusTopRight instead.',
    table: {
      type: { summary: 'BorderRadius' },
      category: 'Border',
      subcategory: 'Border Top',
      disable: true,
    },
  },
  borderTopStyle: {
    control: 'select',
    options: borderTopStyleOptions,
    description: 'Top border style (none, solid, or dashed)',
    table: {
      type: { summary: 'none | solid | dashed' },
      category: 'Border',
      subcategory: 'Border Top',
    },
  },
  borderTopColour: {
    control: 'select',
    options: borderTopColourOptions,
    description: 'Top border color using semantic color tokens',
    table: {
      type: { summary: 'BorderColor' },
      category: 'Border',
      subcategory: 'Border Top',
    },
  },
  borderRightWidth: {
    control: 'select',
    options: borderRightWidthOptions,
    description: 'Right border width using design system tokens',
    table: {
      type: { summary: 'BorderWidth' },
      category: 'Border',
      subcategory: 'Border Right',
    },
  },
  borderRightRadius: {
    control: 'select',
    options: borderRightRadiusOptions,
    description:
      '@deprecated Use borderRadiusTopRight and borderRadiusBottomRight instead.',
    table: {
      type: { summary: 'BorderRadius' },
      category: 'Border',
      subcategory: 'Border Right',
      disable: true,
    },
  },
  borderRightStyle: {
    control: 'select',
    options: borderRightStyleOptions,
    description: 'Right border style (none, solid, or dashed)',
    table: {
      type: { summary: 'none | solid | dashed' },
      category: 'Border',
      subcategory: 'Border Right',
    },
  },
  borderRightColour: {
    control: 'select',
    options: borderRightColourOptions,
    description: 'Right border color using semantic color tokens',
    table: {
      type: { summary: 'BorderColor' },
      category: 'Border',
      subcategory: 'Border Right',
    },
  },
  borderBottomWidth: {
    control: 'select',
    options: borderBottomWidthOptions,
    description: 'Bottom border width using design system tokens',
    table: {
      type: { summary: 'BorderWidth' },
      category: 'Border',
      subcategory: 'Border Bottom',
    },
  },
  borderBottomRadius: {
    control: 'select',
    options: borderBottomRadiusOptions,
    description:
      '@deprecated Use borderRadiusBottomLeft and borderRadiusBottomRight instead.',
    table: {
      type: { summary: 'BorderRadius' },
      category: 'Border',
      subcategory: 'Border Bottom',
      disable: true,
    },
  },
  borderBottomStyle: {
    control: 'select',
    options: borderBottomStyleOptions,
    description: 'Bottom border style (none, solid, or dashed)',
    table: {
      type: { summary: 'none | solid | dashed' },
      category: 'Border',
      subcategory: 'Border Bottom',
    },
  },
  borderBottomColour: {
    control: 'select',
    options: borderBottomColourOptions,
    description: 'Bottom border color using semantic color tokens',
    table: {
      type: { summary: 'BorderColor' },
      category: 'Border',
      subcategory: 'Border Bottom',
    },
  },
  borderLeftWidth: {
    control: 'select',
    options: borderLeftWidthOptions,
    description: 'Left border width using design system tokens',
    table: {
      type: { summary: 'BorderWidth' },
      category: 'Border',
      subcategory: 'Border Left',
    },
  },
  borderLeftRadius: {
    control: 'select',
    options: borderLeftRadiusOptions,
    description:
      '@deprecated Use borderRadiusTopLeft and borderRadiusBottomLeft instead.',
    table: {
      type: { summary: 'BorderRadius' },
      category: 'Border',
      subcategory: 'Border Left',
      disable: true,
    },
  },
  borderLeftStyle: {
    control: 'select',
    options: borderLeftStyleOptions,
    description: 'Left border style (none, solid, or dashed)',
    table: {
      type: { summary: 'none | solid | dashed' },
      category: 'Border',
      subcategory: 'Border Left',
    },
  },
  borderLeftColour: {
    control: 'select',
    options: borderLeftColourOptions,
    description: 'Left border color using semantic color tokens',
    table: {
      type: { summary: 'BorderColor' },
      category: 'Border',
      subcategory: 'Border Left',
    },
  },
  borderRadiusTopLeft: {
    control: 'select',
    options: borderRadiusTopLeftOptions,
    description: 'Top-left corner border radius using design system tokens',
    table: {
      type: { summary: 'BorderRadius' },
      category: 'Border',
      subcategory: 'Border Radius',
    },
  },
  borderRadiusTopRight: {
    control: 'select',
    options: borderRadiusTopRightOptions,
    description: 'Top-right corner border radius using design system tokens',
    table: {
      type: { summary: 'BorderRadius' },
      category: 'Border',
      subcategory: 'Border Radius',
    },
  },
  borderRadiusBottomLeft: {
    control: 'select',
    options: borderRadiusBottomLeftOptions,
    description: 'Bottom-left corner border radius using design system tokens',
    table: {
      type: { summary: 'BorderRadius' },
      category: 'Border',
      subcategory: 'Border Radius',
    },
  },
  borderRadiusBottomRight: {
    control: 'select',
    options: borderRadiusBottomRightOptions,
    description: 'Bottom-right corner border radius using design system tokens',
    table: {
      type: { summary: 'BorderRadius' },
      category: 'Border',
      subcategory: 'Border Radius',
    },
  },
};
